<template>
	<div class="o-l-l">
		<div class="item pointer" :class="{on:type == '/'}" @click="pageTo('/')">网站首页</div>
		<div class="item pointer" @click="show1 = !show1">我的主页<i class="el-icon-arrow-up" v-if="show1"></i><i
				class="el-icon-arrow-down" v-else></i></div>
		<div class="slist" v-if="show1">
			<div class="i pointer" :class="{on:type == 'user'}" @click="pageTo('user')">个人中心</div>
			<div class="i pointer" :class="{on:type == 'credit'}" @click="pageTo('credit')">授信管理</div>
			<div class="i pointer" :class="{on:type == 'myShop'}" @click="pageTo('myShop')">我的店铺</div>
		</div>
		<div class="item pointer" @click="show2 = !show2">订单中心<i class="el-icon-arrow-up" v-if="show2"></i><i
				class="el-icon-arrow-down" v-else></i></div>
		<div class="slist" v-if="show2">
			<div class="i pointer" :class="{on:type == 'orderList'}" @click="pageTo('orderList')">订单列表</div>
			<div class="i pointer" :class="{on:type == 'afterSalesList'}" @click="pageTo('afterSalesList')">售后管理</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'hekLeft',
		props: {
			type: {
				type: String,
				default: '/'
			}
		},
		data() {
			return {
				show1: false,
				show2: false,
			};
		},
		created() {
			console.log(this.type, 'this.type')
			this.show1 = this.type == 'user' || this.type == 'credit' || this.type == 'myShop'
			this.show2 = this.type == 'orderList' || this.type == 'afterSalesList'

		},
		methods: {
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},

		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.o-l-l {
		width: 100px;

		.item {
			width: 100%;
			height: 60px;
			line-height: 60px;
			font-size: 16px;
			color: @color1;
			font-weight: 600;
			display: flex;
			align-items: center;
			justify-content: space-between;

			i {

				font-size: 14px;

			}
		}

		.slist {
			width: 100%;

			.i {
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				color: @color1;
				text-align: center;
			}

			.on,
			.i:hover {
				position: relative;
				color: @color2;

				&::after {
					content: '';
					position: absolute;
					top: 50%;
					left: 5px;
					width: 3px;
					height: 14px;
					background: @color2;
					border-radius: 4px 4px 4px 4px;
					margin-top: -7px;
				}

			}
		}
	}
</style>